var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.999975 11.3C0.816642 11.1167 0.724976 10.8833 0.724976 10.6C0.724976 10.3167 0.816642 10.0833 0.999975 9.89999L4.89998 5.99999L0.999975 2.09999C0.816642 1.91665 0.724976 1.68332 0.724976 1.39999C0.724976 1.11665 0.816642 0.883321 0.999975 0.699987C1.18331 0.516654 1.41664 0.424988 1.69998 0.424988C1.98331 0.424988 2.21664 0.516654 2.39998 0.699987L6.99998 5.29999C7.09998 5.39999 7.17098 5.50832 7.21298 5.62499C7.25431 5.74165 7.27498 5.86665 7.27498 5.99999C7.27498 6.13332 7.25431 6.25832 7.21298 6.37499C7.17098 6.49165 7.09998 6.59999 6.99998 6.69999L2.39998 11.3C2.21664 11.4833 1.98331 11.575 1.69998 11.575C1.41664 11.575 1.18331 11.4833 0.999975 11.3Z",
    fill: "#0F172A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.76a4d66fdc46ba74d8e40e726a1055ba.svg";
export { ForwardRef as ReactComponent };